import { render } from "./Artists.vue?vue&type=template&id=29e3cd25&scoped=true"
import script from "./Artists.vue?vue&type=script&lang=js"
export * from "./Artists.vue?vue&type=script&lang=js"

import "./Artists.vue?vue&type=style&index=0&id=29e3cd25&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e3cd25"]])

export default __exports__